let isEnabled: any;
function checkIfFreemiumFeatureEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled =
            window.dazn.features.isEnabledAnonymous('f_catalog_freemium');
        isEnabled = isFeatureEnabled;
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
}

let isShowPlayIconOnTileEnabled: any;
function checkIfShowPlayIconOnTileEnabled() {
    if (isShowPlayIconOnTileEnabled !== undefined)
        return isShowPlayIconOnTileEnabled;
    try {
        isShowPlayIconOnTileEnabled =
            window.dazn.features.getVariableBooleanAnonymous(
                'f_catalog_freemium',
                'ShowPlayIconOnTile'
            );
        return isShowPlayIconOnTileEnabled;
    } catch (e) {
        return false;
    }
}

let isExploreButtonEnabled: any;
function checkIfShowLPExploreButtonEnabled() {
    if (isExploreButtonEnabled !== undefined) return isExploreButtonEnabled;
    try {
        isExploreButtonEnabled =
            window.dazn.features.getVariableBooleanAnonymous(
                'f_catalog_freemium',
                'ShowLPExploreButton'
            );
        return isExploreButtonEnabled;
    } catch (e) {
        return false;
    }
}

export {
    checkIfFreemiumFeatureEnabled,
    checkIfShowPlayIconOnTileEnabled,
    checkIfShowLPExploreButtonEnabled
};
